import { RolePermissionObjects } from './rolePermissionObjects.constants';

export const sampleRouteConfig = [
    { routerLink: '/dashboard/samples/sample', title: 'Samples', objectId: RolePermissionObjects.Sample },
    { routerLink: '/dashboard/samples/survey', title: 'Survey', objectId: RolePermissionObjects.Survey },
    { routerLink: '/dashboard/samples/lab-requisition', title: 'Lab Requisition', objectId: RolePermissionObjects.LabRequisition },
    { routerLink: '/dashboard/samples/templates', title: 'Templates', objectId: RolePermissionObjects.SampleTemplate }
]
